<template>
	<div class='tw-flex tw--mx-3'>
		<div class="px-3" :class="{ 'tw-w-full' : fullWidth, 'tw-w-2/3': !fullWidth }">
			<div class="mb-4">
				<slot name="stepper"></slot>
			</div>
			<slot name="content"></slot>
		</div>
		<div class="tw-w-1/3 px-3" v-if="!fullWidth">
			<slot name="description"></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ValuationLayout',
	props: ['fullWidth'],
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/commons/ValuationLayout.vue